import React, { useEffect, useState } from 'react';

import "./Usuario.css";

import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { UsuarioColumnList } from './UsuarioConstants';
import { fetchGetRolesByUser } from '../../reducers/rolSlice';
import ConjuntoSelector from '../../components/ConjuntoSelector';
import { fetchUpdateUsuario_conjunto_rol } from '../../reducers/usuario_conjunto_rolSlice';
import { toast } from 'react-toastify';

function Usuario(props) {
    const { usuarioId } = props;

    const [selectedUsuario, setSelectedUsuario] = useState();
    const [selConjunto, setSelConjunto] = useState();
    const [userRoles, setUserRoles] = useState();
    const [roles, setRoles] = useState();

    const moduleData = useSelector((state) => state.usuario);

    const { t } = useTranslation();

    useEffect(() => {
        if (usuarioId) {

            const selUsuario = moduleData?.usuarioList?.find(ad => ad.id === usuarioId);
            setSelectedUsuario(selUsuario);
            updateRolList(usuarioId);
        }
    }, [usuarioId]);

    const updateRolList = async (usuarioId) => {
        const response = await fetchGetRolesByUser(usuarioId);
        setUserRoles(response.userRoles);
        setRoles(response.roles);
    }

    const renderItem = (ccl) => {
        return (
            <div className='item' key={`info-item-${ccl.dbname}`}>
                <div className='title'>{t(ccl.label)}:</div>
                <div className='content'>{selectedUsuario[ccl.dbname]}</div>
            </div>
        )
    }

    const handleChangePermission = (ev, value) => {
        var newSels = [...userRoles];
        const selRol = newSels?.find(ur => ur.rol_id === value && ur.conjunto_id === selConjunto);
        if (ev.target.checked) {
            if (selRol) {
                if (selRol.ucr_id && selRol.action) {
                    delete selRol.action;
                }
            } else {
                newSels.push({ rol_id: value, conjunto_id: selConjunto });
            }
        } else {
            if (selRol) {
                if (selRol.ucr_id) {
                    selRol.action = 'del';
                } else {
                    newSels = newSels?.filter(ur => ur.rol_id !== value && ur.conjunto_id === selConjunto);
                }
            } else {
                console.log('no deberia pasar');
            }
        }
        setUserRoles(newSels || []);
    }

    const handleAdd = async () => {
        const toUpdate = userRoles?.filter(ur => !ur.ucr_id || ur.action);
        if (toUpdate.length > 0) {
            const response = await fetchUpdateUsuario_conjunto_rol(toUpdate.map(tu => {
                if (tu.ucr_id)
                    return { ...tu };
                const uc = userRoles?.find((ur => ur.conjunto_id === tu.conjunto_id && !!ur.uc_id));
                return { ...tu, usuario_id: usuarioId, uc_id: uc?.uc_id, action: 'ins' }
            }));

            if (response?.statusCode === 200) {
                toast(t("UPDATED_OK"));
                updateRolList(usuarioId);
            }
        }
    }

    const handleConjuntoChange = (dbname, conjuntoId, selName) => {
        setSelConjunto(conjuntoId);
    }

    const renderRoles = () => {
        return (
            <div>
                {
                    selConjunto && roles?.map(r => (
                        <div className="form-check" key={`user_roles_${r.id}`} >
                            <input
                                className="form-check-input"
                                type="checkbox"
                                id={`user_rol_list_${r.nombre}_${usuarioId}`}
                                onChange={(ev) => { handleChangePermission(ev, r.id) }}
                                checked={!!userRoles?.find(ur => ur.rol_id === r.id && ur.conjunto_id === selConjunto)}
                            /><label className="form-check-label" htmlFor={`user_rol_list_${r.nombre}_${usuarioId}`}> {r.nombre} </label>
                        </div>
                    ))
                }
            </div>
        )
    }

    return (
        <div
            className="modal"
            id={`usuario_detail_modal`}
            data-bs-backdrop="static"
            tabIndex="-1"
            aria-hidden="true"
        >
            <div className="modal-dialog  modal-xl modal-administrator" >

                <div className="modal-content">
                    <div className="modal-header">
                        <h5 className="modal-title" id="backDropModalTitle">{selectedUsuario?.nombre} Info</h5>
                        <button
                            type="button"
                            className="btn-close"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                        ></button>
                    </div>
                    <div className="modal-body">
                        <div className='module-info-container'>
                            <div className='module-info-data' >
                                {
                                    selectedUsuario && UsuarioColumnList().filter(ccl => ccl.form === true && ccl.type !== 'password').map(ccl => (renderItem(ccl)))
                                }
                            </div>
                            <div className='usuario-info-administradores'>
                                <div className='box-title sp-btw'>
                                    <div>{t("roles")}</div>
                                    <div><ConjuntoSelector onChange={handleConjuntoChange} /></div>
                                </div>
                                <div className='box-content'>
                                    <div className='rol-modulo-permisos'>{renderRoles()}</div>
                                </div>
                                <div className='box-button'>
                                    <div className='btn btn-primary' onClick={handleAdd}>{t("actualizar")}</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>

            </div>
        </div>
    );
}

export default Usuario;